import { render, staticRenderFns } from "./about-news.vue?vue&type=template&id=43ecbda2&scoped=true&"
import script from "./about-news.vue?vue&type=script&lang=js&"
export * from "./about-news.vue?vue&type=script&lang=js&"
import style0 from "./about-news.vue?vue&type=style&index=0&id=43ecbda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ecbda2",
  null
  
)

export default component.exports